import { HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { getHostname } from '../shared/services/hostname-utils.service';

function isIntranet() {
  const hostname = getHostname();
  return hostname.endsWith('.net');
}

function getBackendUrl(req: HttpRequest<unknown>) {
  const source = isIntranet() ? 'intranet' : 'internet';
  const urls = environment.backendUrls[source];
  const pathMap = environment.services;
  for (const [alias, prefix] of Object.entries(pathMap)) {
    if (req.url.startsWith(prefix)) {
      return req.url.replace(prefix, urls[alias as keyof typeof urls]);
    }
  }
  return req.url;
}

export const backendResolverInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.url.includes('emea') || req.url.includes('oauth2')) {
    return next(req);
  } else {
    const updatedReq = req.clone({
      url: getBackendUrl(req),
      setHeaders: { 'x-apikey': environment.xapikey },
    });
    return next(updatedReq);
  }
};
